import moment from 'moment';

export const formatDate = (timestamp) => {
    if (!timestamp) return "";
    return moment.unix(timestamp).format("DD-MM-YYYY");
};

export const formatDateWithTime = (timestamp) => {
    if (!timestamp) return "";
    return moment.unix(timestamp).format("DD-MM-YYYY HH:mm:ss A");
};

export const formatDateWithTimeWithoutSec = (timestamp) => {
    if (!timestamp) return "";
    return moment.unix(timestamp).format("DD-MM-YYYY HH:mm A");
};

export const formatLatestDate = (timestamp) => {
    if (!timestamp) return "";

    const date = moment.unix(timestamp);
    const today = moment().startOf("day");
    const yesterday = moment().subtract(1, "day").startOf("day");

    if (date.isSame(today, "d")) {
        return "Today";
    } else if (date.isSame(yesterday, "d")) {
        return "Yesterday";
    } else {
        return date.format("DD-MM-YYYY");
    }
};

export const formatDateLegacy = (date) => {
    if (!date) return "";

    try {
        const dateObj = new Date(date);
        if (isNaN(dateObj.getTime())) return date;

        return dateObj.toLocaleDateString("en-US", {
            year: "numeric",
            month: "short",
            day: "numeric",
        });
    } catch (error) {
        return date;
    }
};

export const formatTime = (time) => {
    if (!time) return "";

    try {
        const dateObj = new Date(time);
        if (isNaN(dateObj.getTime())) return time;

        return dateObj.toLocaleTimeString("en-US", {
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
        });
    } catch (error) {
        return time;
    }
};

export const formatDateTime = (dateTime) => {
    if (!dateTime) return "";

    try {
        const dateObj = new Date(dateTime);
        if (isNaN(dateObj.getTime())) return dateTime;

        const date = dateObj.toLocaleDateString("en-US", {
            year: "numeric",
            month: "short",
            day: "numeric",
        });

        const time = dateObj.toLocaleTimeString("en-US", {
            hour: "2-digit",
            minute: "2-digit",
        });

        return `${date} ${time}`;
    } catch (error) {
        return dateTime;
    }
};

export const getTimeAgo = (date) => {
    if (!date) return "";

    try {
        const dateObj = new Date(date);
        const now = new Date();
        const diffMs = now - dateObj;
        const diffSecs = Math.floor(diffMs / 1000);
        const diffMins = Math.floor(diffSecs / 60);
        const diffHours = Math.floor(diffMins / 60);
        const diffDays = Math.floor(diffHours / 24);

        if (diffSecs < 60) return "just now";
        if (diffMins < 60) return `${diffMins}m ago`;
        if (diffHours < 24) return `${diffHours}h ago`;
        if (diffDays < 7) return `${diffDays}d ago`;

        return dateObj.toLocaleDateString("en-US", {
            year: "numeric",
            month: "short",
            day: "numeric",
        });
    } catch (error) {
        return date;
    }
};
